document.addEventListener('DOMContentLoaded', function () {
  $('.custom-carousel1').slick({
    slidesToShow: 3, // Number of items to show
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    swipeToSlide: true, // Smooth scrolling effect
    cssEase: 'linear', // Smoother scrolling transition
    infinite: true,
    arrows: true,
    dots: true, // Enable dots for pagination
    // prevArrow: '<button class="slick-prev">‹</button>',
    // nextArrow: '<button class="slick-next">›</button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  });
    $('.custom-carousel2').slick({
    slidesToShow: 4, // Number of items to show
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    swipeToSlide: true, // Smooth scrolling effect
    cssEase: 'linear', // Smoother scrolling transition
    infinite: true,
    arrows: true,
    dots: true, // Enable dots for pagination
    // prevArrow: '<button class="slick-prev">‹</button>',
    // nextArrow: '<button class="slick-next">›</button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  });
});
